<template>
  <div class="product-download-container" :class="{ 'single-card': productDownloads.length === 1 }">
    <div v-for="{ id, name, release, badge } in productDownloads" v-bind:key="name" class="product-download-card">
      <ProductDownloadCard :id="id" :name="name" :release="release" :badge="badge" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from '@/store/DownloadStore'
import { storeToRefs } from 'pinia'
import ProductDownloadCard from '@/components/shared/screens/ProductDownloadCard.vue'

const downloadStore = useDownloadStore()
const { productDownloads } = storeToRefs(downloadStore)
</script>

<style lang="scss" scoped>
.product-download-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: $spacer-3;
  margin-bottom: 48px;

  &.single-card {
    grid-template-columns: 1fr;
  }

  @include media-breakpoint(md) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
